const API_URL = "https://tuly.app/api/";
//const API_URL = "http://localhost:5000/api/";

export const fetchTools = async (query, token) => {
  try {
    const response = await fetch(`${API_URL}tools/search`, {
      method: 'POST',
      body: JSON.stringify({
        query: query
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${token}` // Send auth token
      }
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const fetchSubTaskedTools = async (query, token) => {
  try {
    const response = await fetch(`${API_URL}tools/optimizedsearch`, {
      method: 'POST',
      body: JSON.stringify({
        query: query
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${token}` // Send auth token
      }
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const landingSearch = async (query, token) => {
  try {
    const response = await fetch(`${API_URL}tools/landingsearch`, {
      method: 'POST',
      body: JSON.stringify({
        query: query
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      }
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const fetchToolByCategory = async (query) => {
  try {
    const response = await fetch(`${API_URL}tools/filterbycatg?query=${query}`);
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const fetchCategories = async () => {
  try {
    const response = await fetch(`${API_URL}categories`);
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const rateTool = async (toolid, star, review, token ) => {
  try {
    const response = await fetch(`${API_URL}tools/${toolid}/rate`, {
      method: 'POST',
      body: JSON.stringify({
        stars: star,
        comment: review
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${token}` // Send auth token
      }
    });
    
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const recordToolView = async (toolid, token ) => {
  try {
    const response = await fetch(`${API_URL}tools/${toolid}/toolview`, {
      method: 'POST',
      body: JSON.stringify({
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${token}` // Send auth token
      }
    });
    
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const toolLinkClicked = async (toolid, token ) => {
  try {
    const response = await fetch(`${API_URL}tools/${toolid}/toolopen`, {
      method: 'POST',
      body: JSON.stringify({
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${token}` // Send auth token
      }
    });
    
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const userLogin = async (mail, pass ) => {
  try {
    const response = await fetch(`${API_URL}users/login`, {
      method: 'POST',
      body: JSON.stringify({
        email: mail,
        password: pass
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      }
    });
    
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const userRegister = async (fname, lname ,mail, pass ) => {
  try {
    const response = await fetch(`${API_URL}users/register`, {
      method: 'POST',
      body: JSON.stringify({
        fname: fname,
        lname: lname,
        email: mail,
        password: pass
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      }
    });
    
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const loggedByGoogle = async (fname, lname, email, picture) => {
  try {
    const response = await fetch(`${API_URL}users/google-login`, {
      method: 'POST',
      body: JSON.stringify({
        given_name: fname,
        family_name: lname,
        email: email,
        picture: picture
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      }
    });
    
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const getUserProfile = async ( token ) => {
  try {
    const response = await fetch(`${API_URL}users/profile`, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${token}` // Send auth token
      }
    });
    
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const fetchHistory = async (token) => {
  try {
    const response = await fetch(`${API_URL}utils/history`, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${token}` // Send auth token
      }
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const fetchCategory = async (catgid) => {
  try {
    const response = await fetch(`${API_URL}categories/${catgid}`, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      }
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const fetchTool = async (toolid, token) => {
  try {
    const response = await fetch(`${API_URL}tools/${toolid}/findtool`, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      }
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

export const postFeedback = async (token, rate, comment) => {
  try {
    const response = await fetch(`${API_URL}utils/feedback`, {
      method: 'POST',
      body: JSON.stringify({
        rate: rate,
        feedback: comment
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${token}` // Send auth token
      }
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

// Function to suggest a new tool
export const suggestTool = async (toolData, token) => {
  try {
    const response = await fetch(`${API_URL}suggestedtool/`, {
      method: 'POST',
      body: JSON.stringify(toolData),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to submit tool suggestion');
    }

    return await response.json();
  } catch (error) {
    console.error('Error suggesting tool:', error);
    throw error;
  }
};

// Function to suggest a new tool
export const searchByName = async (query) => {

  try {
    const response = await fetch(`${API_URL}tools/searchbyname?query=${query}`);
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

// Function to get the top reated tools
export const topRatedTools = async (query) => {

  try {
    const response = await fetch(`${API_URL}tools/toprated`);
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

// Function to activate the account 
export const activateUserAccount = async (token) => {
  try {
    const response = await fetch(`${API_URL}users/accountactivation/${token}`);
    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

// Function to activate the account 
export const resendActivationMail = async (mail) => {
  try {
    const response = await fetch(`${API_URL}users/resendMail`, {
      method: 'POST',
      body: JSON.stringify({
        email : mail
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      }
    });

    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};


// Function to set new password to account 
export const forgotAccountPassword = async (mail) => {
  try {
    const response = await fetch(`${API_URL}users/forgot-password`, {
      method: 'POST',
      body: JSON.stringify({
        email : mail
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      }
    });

    return await response.json();
  } catch (error) {
    console.error("Error fetching tools:", error);
    return [];
  }
};

// Function to reset password of the account 
export const resetPassword = async (token, newPassword, confirmPassword) => {
  try {
    const response = await fetch(`${API_URL}users/resetpassword/${token}`,{
      method: 'POST',
      body: JSON.stringify({
        newPassword : newPassword,
        confirmPassword : confirmPassword
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      }
    });

    return await response.json();
  } catch (error) {
    console.log("Error reseting password tools:", error);
    return [];
  }
};

// --------- Workflow APIs -------- 

export const getTulyFlow = async (query, token, current_date) => {
  try {
    const response = await fetch(`${API_URL}tools/tulyfolw`, {
      method: 'POST',
      body: JSON.stringify({
        query: query,
        clientDate: current_date
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${token}` // Send auth token
      }
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
};

export const getAnonymousTulyFlow = async (query, current_date) => {
  try {
    const response = await fetch(`${API_URL}tools/anonymousFlow`, {
      method: 'POST',
      body: JSON.stringify({
        query: query,
        clientDate: current_date
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      }
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
};

export const getExecutiveReport = async (query, token) => {
  try {
    console.log('Recevied the request <-');

    const response = await fetch(`${API_URL}tools/exe_report`, {
      method: 'POST',
      body: JSON.stringify({
        query: query
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${token}` // Send auth token
      }
    });

    return await response.json();
  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
};

// -------- Threads APIs ---------

export const allThreads = async (token) => {
  try {
    const response = await fetch(`${API_URL}threads/allthreads`, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${token}` // Send auth token
      }
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
};

export const createAThread = async (token, threadId, name, query, response) => {
  try {
    const res = await fetch(`${API_URL}threads/addthread`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        threadId: threadId,
        threadName: name || 'My Workflow',
        query: query,
        response: response
      })
    });

    if (!res.ok) throw new Error('Failed to create thread');

    return await res.json();
  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
};

export const createSearchThread = async (token, threadId, name) => {
  try {
    const res = await fetch(`${API_URL}threads/createthread`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        threadId: threadId,
        threadName: name
      })
    });
    if (!res.ok) throw new Error('Failed to create thread');
    return await res.json();

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
};

export const appendSearchToThread = async (token, threadId, query, response) => {
  try {
    const res = await fetch(`${API_URL}threads/addsearchtothread`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        threadId: threadId,
        query: query,
        response: response
      })
    });
    if (!res.ok) throw new Error('Failed to create thread');
    return await res.json();

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
};

export const getThreadById = async (token, threadId) => {
  try {
    const res = await fetch(`${API_URL}threads/thread/${threadId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    });

    if (!res.ok) throw new Error('Failed to create thread');
    return await res.json();
  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
};

export const removeSearch = async (token, threadId, searchId) => {
  try {
    const res = await fetch(`${API_URL}threads/thread/${threadId}/searches/${searchId}`, {
      method: 'delete',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    });

    if (!res.ok) throw new Error('Failed to create thread');

    return await res.json();
  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
};

export const generateShareLink = async (token, threadId, searchId, shareId) => {
  try {
    const res = await fetch(`${API_URL}threads/${threadId}/entry/${searchId}/share`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        accessLevel: 'view',
        shareId: shareId
      })
    });

    const data = await res.json();

    console.log(data);

    if (data.responsecode != 200) {
      throw new Error('Failed to create share link')
    };
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
};


export const inviteMailShare = async (token, threadId, searchId, shareId, recieverMail) => {
  try {
    const res = await fetch(`${API_URL}threads/${threadId}/entry/${searchId}/send-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        accessLevel: 'view',
        shareId: shareId,
        email: recieverMail
      })
    });

    const data = await res.json();

    if (data.responsecode != 200) {
      throw new Error('Failed to send share link');
    };
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
};

export const getSharedWorkflow = async (shareId) => {
  try {
    const res = await fetch(`${API_URL}threads/share/${shareId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
};

export const getGitexWorkflow = async (shareId) => {
  try {
    const res = await fetch(`${API_URL}threads/gitex/${shareId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
};

export const generateGitexFlow = async (prompt, clientDate, email, phoneNo) => {
  try {
    const res = await fetch(`${API_URL}tools/gitexflow`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        query: prompt,
        clientDate: clientDate,
        email: email,
        phoneNo: phoneNo
      })
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
};

// --------------------------------------------------------

// Posters Generate 
export const makePoster = async (query, threadId, font, token) => {
  
  try {

    const res = await fetch(`${API_URL}poster/text-to-image-poster`, {
      method: "POST",
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ query: query, font_type:font, threadId: threadId })
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
}

// Posters Generate with Image Upload
// Posters Generate with Image Upload
export const makePosterWithImage = async (query, threadId, font, token, file) => {
  try {

    const formData = new FormData();
    formData.append("imageFile", file);
    formData.append("query", query);
    formData.append("font_type", font);
    formData.append("threadId", threadId);
    
    const res = await fetch(`${API_URL}poster/image-to-image-poster`, {  
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData
    });
    
    // Check if response is ok
    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(`HTTP error! status: ${res.status}, message: ${errorText}`);
    }
    
    const data = await res.json();
    return data;
    
  } catch (error) {
    console.error("Error fetching the workflow:", error);
    throw error; // Re-throw to let caller handle it
  }
}

//Modify Poster by Query
export const renderPoster = async (imageRecordId, subPromptId, query, font, token) => {
  
  try {
    const res = await fetch(`${API_URL}poster/render-poster`, {
      method: "POST",
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ imageRecordId, query, subPromptId, font_type:font })
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
}


//Modify Poster Directly by Tool Render
export const directRender = async (imageRecordId, subPromptId, image_arabic_text, text_size, text_color, text_position_x, text_position_y, font, effect, token) => {
  //alert("here");
  try {
    const res = await fetch(`${API_URL}poster/direct-render`, {
      method: "POST",
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ imageRecordId, subPromptId, image_arabic_text , text_size, text_color, text_position_x, text_position_y, font_effect: effect, font_type:font })
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
}

export const getThreadRecords = async (thread, token) => {
  
  try {
    const res = await fetch(`${API_URL}poster/thread-records`, {
      method: "POST",
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ threadId: thread })
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
}

// Projects APIs

export const addProject = async (title, description, token) => {
  
  try {
    const res = await fetch(`${API_URL}poster/add-project`, {
      method: "POST",
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ title: title, description: description })
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
}

export const getProjects = async (token) => {
  
  try {
    const res = await fetch(`${API_URL}poster/projects`, {
      method: "GET",
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`
      }
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
}

export const updateProject = async (projectId, title, description, token) => {
  
  try {
    const res = await fetch(`${API_URL}poster/update-project/${projectId}`, {
      method: "PUT",
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ title: title, description: description })
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
}

export const removeProject = async (projectId, token) => {
  
  try {
    const res = await fetch(`${API_URL}poster/remove-project/${projectId}`, {
      method: "DELETE",
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`
      }
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
}

// Threads APIs

export const addThread = async (projectId, title, description, token) => {
  
  try {
    const res = await fetch(`${API_URL}poster/add-thread`, {
      method: "POST",
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ projectId: projectId, title: title, description: description })
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }

}

export const getThreads = async (projectId, token) => {

  try {
    const res = await fetch(`${API_URL}poster/threads/${projectId}`, {
      method: "GET",
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`
      }
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
}

export const updateThread = async (threadId, title, description, status, projectId, token) => {
  
  try {
    const res = await fetch(`${API_URL}poster/update-thread/${threadId}`, {
      method: "PUT",
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ title: title, description: description, status: status, projectId: projectId })
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
}

export const removeThread = async (threadId, token) => {
  
  try {
    const res = await fetch(`${API_URL}poster/remove-thread/${threadId}`, {
      method: "DELETE",
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`
      }
    });

    const data = await res.json();
    
    return data;

  } catch (error) {
    console.error("Error fetching the workflow:", error);
    return [];
  }
}




